import styled from "styled-components";

import { handleHideAtBreakpoint } from "./helpers";

export const HiddenContainer = styled.span`
    ${({ breakpoint }) => handleHideAtBreakpoint({ breakpoint })}
`;
